enum Instruction {
  L = "L",
  R = "R",
  M = "M",
}

export default Instruction